import React from 'react';
import { DatePicker } from 'antd';
import { shape } from 'prop-types';

import Base from './Base';

const { RangePicker } = DatePicker;

const valueExtractor = value => value;

const AntdRangePicker = props => {
  const { style } = props;
  return (
    <Base
      {...props}
      style={{ ...style, width: '100%' }}
      component={RangePicker}
      valueExtractor={valueExtractor}
      showTime={{ format: 'HH:mm' }}
      format="YYYY-MM-DD HH:mm"
    />
  );
};

AntdRangePicker.propTypes = {
  style: shape({}),
};

AntdRangePicker.defaultProps = {
  style: {},
};

export default AntdRangePicker;
